import React, { useState } from 'react';
import {
  Box,
  Snackbar,
  Alert,
  Container,
} from '@mui/material';
import LibraryDetails from './LibraryDetails';
import DesktopNav from '../../components/DesktopNav';
import LibrarianBottomNav from '../../components/LibrarianBottomNav';

function LibraryDetailsPage() {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'transparent' }}>
      <DesktopNav />

      <Box sx={{ minHeight: 'calc(100vh - 64px)', pb: '90px' }}>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          <LibraryDetails showSnackbar={showSnackbar} />
        </Container>
      </Box>

      <LibrarianBottomNav />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default LibraryDetailsPage;
